import { createContext, useContext } from 'react';
import { useLocalStorage } from '../../utils/storage';
import { useSettings } from "../../utils/settings";

const StorageContext = createContext();

export function StorageProvider({ children }) {
	const [user, setUser] = useLocalStorage('user', null);
	const [settings, setSettings] = useSettings();	

	// document.documentElement.setAttribute('data-bs-theme', settings.theme);

	document.documentElement.setAttribute('data-theme', settings.theme);

	return (
		<StorageContext.Provider value={{ user, setUser, settings, setSettings }}>
			{children}
		</StorageContext.Provider>
	);
}

export function useStorage() {
	const context = useContext(StorageContext);
	if (!context) {
		throw new Error('useStorage must be used within a StorageProvider');
	}
	return context;
}